<template lang="pug">
  div
    .container-fluid#wrapper
      #title ユーザー検索
      #search-condition
        #keyword
          #search-form(action="" method="get")
            input.form-control(name="s" type="text" placeholder="ユーザー名で検索する" v-model="keyword" @keydown.enter="onKeydownEnter()")
            #search-btn(@click="searchUser()")
              i.fas.fa-search
      #main-content
        #search-results {{resultMessage}}
        #userList.mb-5
          .user(@click="callRouterInfo(item)" v-for="(item,index) in userList" :value="item")
            .d-flex.align-items-center
              .img-col.col-2
                img(:src="createImgPath(item.iconPath)" v-if="!item.iconPath==''")
              .name-col.col-10
                .name.font-weight-bold(@click="callRouterInfo(item)") {{item.name}}
                .profileText.font-weight-light {{item.profileText}}
</template>

<script>
import axios from 'axios'

export default {
  // データオブジェクト
  props:{
  },
  data() {
    return {
      userList:[],
      keyword:'',
      resultMessage:this.DATA_MESSAGE,
      DATA_MESSAGE: 'ユーザー情報を公開しているアカウントのみ表示しています。',
      NO_DATA_MESSAGE: '該当するユーザーは存在しません。'
    }
  },
  created(){
    this.getData('')
  },
  // メソッド
  methods: {
    onKeydownEnter() {
      this.searchUser()
    },
    searchUser(){
      this.getData(this.keyword)
    },
    async getData(keyword) {
      let searchKeyword = ''
      if(keyword != undefined){
        searchKeyword = keyword
      }
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-search-userlist'
      await axios
        .get(jsonUrl,{
          params: {
            "keyword" : searchKeyword
          },         
          headers: {
            'Authorization': this.$user.idToken
          }
        })
        .then(response => {
          this.userList = response.data
          //ログインしている場合、ログインユーザーのデータは公開範囲に関わらず参照可能とする
          if(this.$user.isLogin){
            this.userList.forEach(user => {
              if(user.userId == this.$user.userId){
                user.isPrivate = false 
              }
            })
          }

          if(this.userList.length == 0){
            this.resultMessage = this.NO_DATA_MESSAGE
          }else{
            this.resultMessage = this.DATA_MESSAGE
          }

        })
        .catch(err => {
          this.resultMessage = '情報の取得に失敗しました'
          this.userList = []
        })
    },
    callRouterInfo(item){
      this.$router.push('/myPage/' + item.userId +'/userInfoTop')
    },
    createImgPath(path){
      return this.getStatusIconPath(path)
    },
  },
  // コンポーネント
  components: {
  }
}
</script>
<style lang="stylus" scoped>
#wrapper
  padding-top 10px

  #title
    margin-top 2rem
    text-align center
    font-size 1.5rem
    font-weight 600  
    color #0664A9

  //検索条件
  #search-condition
    height 30px
    margin-bottom 3.5rem
    #keyword
      #search-form
        position relative
        margin 3rem 0
        #search-btn
          position absolute
          right 3%
          top 10%
          background none
          color #666
          border none
          font-size 20px
        #search-btn 
          &:hover 
            cursor pointer
            color #006fbe

  #main-content
    #search-results
      margin 0.5rem 0
    #userList
        border-bottom 1px solid #BDBDBD
      .user
        border-top 1px solid #BDBDBD
        cursor pointer
        :hover
          background #f5f5f5
        .img-col,.name-col
          padding 0.5rem
        .img-col
          text-align: center;
          img
            width 100%
            border-radius 50%
        .name-col
          .name
            font-size 1rem
        .profileText
          font-size 0.8rem
          //最大2行表示で省略記号を付ける。
          display -webkit-box
          -webkit-box-orient vertical
          -webkit-line-clamp 2
          overflow hidden

@media (min-width 992px)
  #wrapper
    width 50%
    #main-content
      #userList
        .user
          .img-col
            img
              width 50%

</style>